import React from 'react'
import api from '../../API/api';
import Swal from 'sweetalert2'


const StudentStatus = (props) => {

    const [status, setStatus] = React.useState('');
    const [remarks, setRemarks] = React.useState('');
    // let student_id = props.modalData.id;



    function handleSubmit() {
        const data = {
            remarks: remarks,
            status: status,
            id: props.modalData.id
        }
        api.studentStatus(data).then(res => {
            props.refreshData();
            props.handleClose();

            Swal.fire({
                title: 'Success!',
                text: res.data.message,
                icon: 'success',
                confirmButtonText: 'Ok'
            })
        }).catch(err => {
            // console.log(err, ' check err status');
        })
    }



    return (
        <div>
            <div className="col-md-12">
                <label>Status</label>
                <select name="course" onChange={(e) => setStatus(e.target.value)} value={status} className='form-control'>
                    <option value="">---</option>
                    <option value='1'>Active</option>
                    <option value='2'>Failed</option>
                    <option value='3'>Drop-out</option>
                    <option value='4'>Others</option>
                </select>
            </div>
            <div className='my-4'></div>
            {
                status === '4' ?
                    <div className="col-md-12">
                        <label>Remarks(optional)</label>
                        <input type="text" className='form-control' onChange={(e) => setRemarks(e.target.value)} />
                    </div>
                    : ''
            }
            <div className='text-center pt-4 mb-0' >
                <button className='btn btn-primary btn-sm' onClick={handleSubmit}> Submit</button>
            </div>
        </div>
    );
}
export default StudentStatus